import { useReactToPrint } from 'react-to-print';

import { styled, Box } from '@mui/material';

import useTableRequestParams from 'hooks/useTableRequestParams';
import Table from '@Components/table';
import { AppBarWithApiRef } from '@Components/app-bar';

import { customerReportColumns } from './columns';
import Papa from 'papaparse';
import { exportData } from '@Utils/export-csv';
import {
  useCustomersReportBySelectedIdMutation,
  useGetCustomersQuery,
  useLazyGetCustomersQuery,
} from '@Store/api/customersSlice';
import { useEffect } from 'react';
import { handleFetchError } from '@Utils/handleError';

const Container = styled(Box)`
  padding: 0px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export function CustomerReport() {
  const tableParams = useTableRequestParams();

  const { data: customersReport, error: tableDataError } =
    useGetCustomersQuery(tableParams);

  const [getAllCustomersReport] = useLazyGetCustomersQuery();

  const [fetchSelectedCustomersReport] =
    useCustomersReportBySelectedIdMutation();

  const handlePrint = useReactToPrint({
    content: () => document.getElementById('customer-report-container'),
  });

  const handleExport = async (selectedIds?: string[]) => {
    const dataToExport = [] as any[];

    if (selectedIds) {
      const history = await fetchSelectedCustomersReport(selectedIds).unwrap();
      history?.forEach((data: any) => {
        dataToExport.push([
          ...customerReportColumns.map((column) =>
            column.valueGetter!({ row: data } as any)
          ),
        ]);
      });
    } else {
      const history = await getAllCustomersReport({
        getAllPages: true,
      } as any).unwrap();
      history?.items?.forEach((data) => {
        dataToExport.push([
          ...customerReportColumns.map((column) =>
            column.valueGetter!({ row: data } as any)
          ),
        ]);
      });
    }
    const csv = Papa.unparse({
      fields: customerReportColumns.map((column) => column.headerName!),
      data: dataToExport,
    });
    exportData(csv);
  };

  useEffect(() => {
    handleFetchError(tableDataError);
  }, [tableDataError]);

  return (
    <Container id='customer-report-container'>
      <Table
        checkboxSelection
        printable
        searchable
        columns={[...customerReportColumns]}
        handleExport={handleExport}
        handlePrint={handlePrint}
        paginated={
          customersReport?.items.length
            ? customersReport.items.length > 0
            : false
        }
        rows={customersReport?.items || []}
        toolbar={AppBarWithApiRef}
        toolbarTitle='Customer Report'
        totalCount={customersReport?.count}
      />
    </Container>
  );
}
